export const transfer = {
  data: [{
    title: '九成新苹果MacBook Pro转让',
    localtion: '成都市青羊区',
    public: "王先生",
    mobile: "15520627628",
    time: "2024-07-30",
    num: "256",
    description: `转让22年自用i7顶配13寸笔记本电脑苹果，笔记本九五新 无拆，无修，无磕碰，无使用问题，速度很流畅，办公软件您多开也不卡，非常流畅。 #笔记本电脑
电脑我平时上课用的，保护很好，基本95新以上，电脑是我22年花一万多买的，然后笔记本基本配置是内存16G，512G固态
`,
imgs: [`/img/二手转让/1.webp`, '/img/二手转让/电脑.webp', '/img/二手转让/电脑1.webp']
  }, {
    title: '闲置健身器材出售',
    localtion: '成都市武侯区',
    public: "李女士",
    mobile: "18583173178",
    time: "2024-07-29",
    num: "198",
    description: `自己买多了不想要了，25公斤重
需要自提
联系我时，请说是在 皓程蔚来 看到的，谢谢！`,
imgs: [`/img/二手转让/2.webp`, '/img/二手转让/2-1.webp']
  }, {
    title: '二手单反相机Canon 5D Mark III',
    localtion: '成都市成华区',
    public: "赵先生",
    mobile: "18582615616",
    time: "2024-07-28",
    num: "322",
    description: `个人闲置99新佳能5D3+佳能24-105红圈镜头+适马50-500长焦镜头低价出让
带佳能24-105原厂镜头和适马50-500长焦。
整体成色自认九九新，具体请自行看图判断，图片都是实拍`,
imgs: [`/img/二手转让/3.webp`, '/img/二手转让/相机.webp', '/img/二手转让/2的副本.webp']
  }, {
    title: '家用电动自行车低价转让',
    localtion: '绵阳市涪城区',
    public: "张先生",
    mobile: "15782215036",
    time: "2024-07-27",
    num: "215",
    imgs: [`/img/二手转让/4.webp`, '/img/二手转让/111.webp', '/img/二手转让/121.webp'],
    description: `1：适用人群：兼职、全职 骑手；上班族、学生、游

2: 电动车：新车、二手车、以租代购、各类换电业务服务

3： 可以先试租 后补尾款差价 ，即可再买断车辆【适用于新骑手和资金紧张的用户】

4： 租金：先用后付、先付后用 都可以

`
  }, {
    title: '全新iPhone 13转让',
    localtion: '成都市锦江区',
    public: "刘女士",
    mobile: "13781790628",
    time: "2024-07-26",
    num: "289",
    imgs: [`/img/二手转让/5.webp`, '/img/二手转让/手机1.webp', '/img/二手转让/2的副本2.webp'],
    description: `个人用的，不是商家，手机全原装没修过
无锁美版插卡即用和国行完全一样，随意还原抹除
面容灵敏，功能全好，屏幕少许划痕贴膜无视，
电池91，后一张爱思验机不怕火炼，
成都自提，当面交易随便验机你我都放心。
`
  }, {
    title: '九成新书桌和椅子套装',
    localtion: '绵阳市游仙区',
    public: "孙先生",
    mobile: "18282187452",
    time: "2024-07-25",
    num: "176",
    imgs: [`/img/二手转让/6.webp`, '/img/二手转让/2的副本3.webp', '/img/二手转让/桌子.webp'],
    description: `厂家直销 定制 各类中高端办公家具
本厂专业生产订制各类中高档办公家具
成都市区免费送货上门安装 免费上门测量尺寸
`
  }, {
    title: '二手钢琴转让',
    localtion: '乐山市市中区',
    public: "周女士",
    mobile: "15682168549",
    time: "2024-07-24",
    num: "203",
    imgs: [`/img/二手转让/7.webp`, '/img/二手转让/钢琴.webp', '/img/二手转让/钢琴1.webp'],
    description: `9年行业积累，
进口二手钢琴库存3000余台
本人做人做事真诚，长期热衷于公益事业，
一直遵从“只有严格把握品控，才能走的更长远”的准则从事本行业，
欢迎自家要用琴的家长采购，全部批发价，一台起批。
`
  }, {
    title: '闲置PS5游戏机转让',
    localtion: '乐山市沙湾区',
    public: "吴先生",
    mobile: "15382126384",
    time: "2024-07-23",
    num: "278",
    imgs: [`/img/二手转让/8.webp`, '/img/二手转让/ps5-1.webp', '/img/二手转让/ps5.webp'],
    description: `国行，轻薄光驱版，硬盘1T，单手柄
三码合一，官方质保还有2年
某东同配置二手机2729，只有一年非官方质保
只支持自提，武侯万达附近
`
  }, {
    title: '二手单人沙发出售',
    localtion: '自贡市自流井区',
    public: "何女士",
    mobile: "13382067813",
    time: "2024-07-21",
    num: "184",
    imgs: [`/img/二手转让/9.webp`, '/img/二手转让/沙发.webp', '/img/二手转让/沙发1.webp'],
    description: `重新装修房子，甩卖用了不到两个月的长生态皮沙发侧妃沙发
现在五折抛售了
`
  }, {
    title: '九成新山地自行车',
    localtion: '宜宾市翠屏区',
    public: "韩先生",
    mobile: "15382114973",
    time: "2024-07-25",
    num: "237",
    imgs: [`/img/二手转让/10.webp`],
    description: `车子是6月份在捷安特实体店买的，本准备买来上下班骑，可上班太累了，现在就闲置在那，车子是黑色的，买来只骑过几次，100公里都没有`
  }, {
    title: '二手空调低价转让',
    localtion: '攀枝花市东区',
    public: "陈女士",
    mobile: "1828214730",
    time: "2024-07-30",
    num: "192",
    imgs: [`/img/二手转让/11.webp`, `/img/二手转让/空调.webp`, `/img/二手转让/空调1.webp`],
    description: `专业从事二手空调经营，实体店经营，有专业师傅安装队伍，质量问题保修。
低价出售：1匹、1.5匹、3匹、5匹中央空调 天花机、柜机、挂机长期有货。
高价回收：长期诚信回收大量二手空调、中央空调、天花机、风管机、柜机、挂机。
`
  }, {
    title: '闲置儿童玩具大甩卖',
    localtion: '乐山市市中区',
    public: "杨先生",
    mobile: "15689143612",
    time: "2024-07-29",
    num: "243",
    imgs: [`/img/二手转让/12.webp`],
    description: `给孩子买的平衡车，耍了几次就不耍了，买价400元，两百元出
联系我时，请说是在 皓程蔚来 看到的，谢谢！
`
  }]
}